export interface DcaScenarioRow extends Record<string, unknown> {
  id: number;
  name: string;
  notes?: string | null;
  area_count: number;
  formation_count: number;
  development_type: string;
  segmentation?: string | null;
  outlier_detection?: string | null;
  early_time_on: boolean;
  oil_configs_count: number;
  gas_configs_count: number;
  water_configs_count: number;
  created_at: string;
  created_by?: string | null;
  updated_at: string;
  updated_by?: string | null;
}

export interface DcaScenariosFilterState {
  createdDateStart: string;
  createdDateEnd: string;
  updatedDateStart: string;
  updatedDateEnd: string;
  createdBy: string;
  developmentType: string;
  areaCountMin: string;
  areaCountMax: string;
  formationCountMin: string;
  formationCountMax: string;
  hasSegmentation: boolean;
  hasOutlierDetection: boolean;
  hasEarlyTime: boolean;
  hasOilConfigs: boolean;
  hasGasConfigs: boolean;
  hasWaterConfigs: boolean;
}

export const DEFAULT_FILTER_STATE: DcaScenariosFilterState = {
  createdDateStart: '',
  createdDateEnd: '',
  updatedDateStart: '',
  updatedDateEnd: '',
  createdBy: '',
  developmentType: '',
  areaCountMin: '',
  areaCountMax: '',
  formationCountMin: '',
  formationCountMax: '',
  hasSegmentation: false,
  hasOutlierDetection: false,
  hasEarlyTime: false,
  hasOilConfigs: false,
  hasGasConfigs: false,
  hasWaterConfigs: false,
};
